import { useState, useCallback } from 'react'

export default function useOpenStates(coverages) {
  const [closedCoverages, setClosedCoverages] = useState([])

  const allOpen = closedCoverages?.length === 0

  const allClosed = closedCoverages?.length === coverages?.length

  const handleToggleOpenAll = useCallback(() => {
    if (allClosed) {
      setClosedCoverages([])
    } else {
      setClosedCoverages(
        coverages.map(({ place }) => {
          return place?.id
        })
      )
    }
  }, [allClosed, coverages])

  const getIsOpen = useCallback(
    (id) => {
      return !closedCoverages.includes(id)
    },
    [closedCoverages]
  )

  const handleToggleOpen = useCallback(
    (id) => {
      setClosedCoverages((curr) => {
        if (closedCoverages.includes(id)) return curr.filter((item) => item !== id)
        return [...curr, id]
      })
    },
    [closedCoverages]
  )

  return { getIsOpen, handleToggleOpenAll, handleToggleOpen, allOpen, allClosed }
}
